import { render, staticRenderFns } from "./EmojiMenu.vue?vue&type=template&id=1b1e01ce&scoped=true&"
import script from "./EmojiMenu.vue?vue&type=script&lang=js&"
export * from "./EmojiMenu.vue?vue&type=script&lang=js&"
import style0 from "./EmojiMenu.vue?vue&type=style&index=0&id=1b1e01ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1e01ce",
  null
  
)

export default component.exports